module.exports = "#version 300 es\n\nin vec4 vs_Pos;\nin vec4 vs_Col;\n\nout vec4 fs_Col;\n\nvoid main()\n{\n    fs_Col = vs_Col;\n\n    gl_Position = vs_Pos;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/background-vert.glsl
// module id = 79
// module chunks = 0